export function translationDocHandler(event: MouseEvent, openFn: (docId: string) => void) {
    const docId = (event.target as HTMLElement).attributes.getNamedItem('id')?.value;

    if (docId) {
        openFn(docId);
    }
}
